import { defineMessages } from 'react-intl';

export const fieldEnhancementOptionsMessages = defineMessages({
  header: {
    id: `app.components.FormBuilder.FieldEnhancementOptions.header`,
    defaultMessage: 'Enhancement options:',
  },
  applyRegexValidationEnabledTooltip: {
    id: `app.components.FormBuilder.FieldEnhancementOptions.applyRegexValidationEnabledTooltip`,
    defaultMessage: 'Remove answer validation',
  },
  applyRegexValidationDisabledTooltip: {
    id: `app.components.FormBuilder.FieldEnhancementOptions.applyRegexValidationDisabledTooltip`,
    defaultMessage: 'Validate answer',
  },
  applyRegexValidationButtonDisabledTooltip: {
    id: `app.components.FormBuilder.FieldEnhancementOptions.applyRegexValidationButtonDisabledTooltip`,
    defaultMessage:
      'This option is not available for standard questions or non-text fields.',
  },
});
